import { EnvironmentProviders, Provider } from '@angular/core';

/** Optional feature kind. */
export enum BarLayoutFeatureKind {
    /** Whether we want date & time interception. */
    Interception,
    /** Custom settings to use for the layout module. */
    CustomSettings,
    /** Use the default settings based on BaaS core state. */
    DefaultSettings,
    /** User GVK with the layout. */
    Gvk,
    /** Burgerprofiel related stuff. */
    Burgerprofiel
}

/** Represents an optional feature for BAR layout.  */
export interface BarLayoutFeature {
    /** What kind of feature. */
    kind: BarLayoutFeatureKind;
    /** Providers within the feature. */
    providers: Array<Provider | EnvironmentProviders>;
}
